import { supabase } from '../supabaseClient';

/**
 * Uploads a base64 image or blob to Supabase Storage and returns the public URL.
 * @param {string|Blob} imageSource - Base64 string or Blob/File object
 * @param {string} projectId - ID of the project
 * @param {string} elementId - ID of the element (for filename)
 * @returns {Promise<string>} - Public URL of the uploaded image
 */
export const uploadImageToSupabase = async (imageSource, projectId, elementId) => {
    try {
        let blob;

        // Convert base64 to blob if necessary
        if (typeof imageSource === 'string' && imageSource.startsWith('data:')) {
            const response = await fetch(imageSource);
            blob = await response.blob();
        } else {
            blob = imageSource;
        }

        // Generate unique path
        const timestamp = Date.now();
        const extension = blob.type.split('/')[1] || 'png';
        const filePath = `project-assets/${projectId}/${elementId}_${timestamp}.${extension}`;

        // Upload to Supabase
        const { data, error } = await supabase.storage
            .from('project-assets')
            .upload(filePath, blob, {
                contentType: blob.type,
                upsert: true
            });

        if (error) throw error;

        // Get public URL
        const { data: { publicUrl } } = supabase.storage
            .from('project-assets')
            .getPublicUrl(filePath);

        return publicUrl;
    } catch (error) {
        console.error('Error uploading image to Supabase:', error);
        throw error;
    }
};
